import { useServiceOptional } from '@toeverything/infra';
import { type RefObject, useLayoutEffect } from 'react';

import { ViewService } from '../services/view';

/**
 * Declares the pane a two- or three-pane layout shows its main content in as the view's main pane
 * while it is mounted. Outside a view there is nothing to declare.
 */
export function useViewMainPane(pane: RefObject<HTMLElement | null>) {
  const view = useServiceOptional(ViewService)?.view;
  useLayoutEffect(() => {
    const element = pane.current;
    if (!view || !element) return;
    return view.registerMainPane(element);
  }, [pane, view]);
}
